<template>
  <el-form-item
    v-if="visible"
    :label="$t('lang.热风') + '：'">
    <el-switch
      v-model="localValue"
      inactive-value="0"
      active-value="1"
      @change="handleChange"
      :disabled="disabled" />
  </el-form-item>
</template>

<script>
export default {
  name: 'OvenHotAir',
  props: {
    // v-model 绑定的值
    value: {
      type: [String, Number],
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    visible() {
      return this.permissions.includes('HOT_AIR');
    },
    disabled() {
      return false;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('change');
    }
  }
};
</script>

